/** Inline toggle with checkbox */
export function InlineToggleField({
  label,
  checked,
  onChange,
}: {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
}) {
  return (
    <div className="flex justify-between items-center gap-2">
      <span className="text-muted-foreground text-xs shrink-0">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        data-testid={`toggle-${label.toLowerCase().replace(/\s+/g, '-')}`}
        className={`relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${checked ? 'bg-primary' : 'bg-muted'
          }`}
        onClick={() => onChange(!checked)}
      >
        <span
          className={`pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform ${checked ? 'translate-x-4' : 'translate-x-0'
            }`}
        />
      </button>
    </div>
  )
}
